import { ScheduleDate, CalculatorResult } from '@akiba/models_beta_temp';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-withdraw-simulation-modal',
  templateUrl: './withdraw-simulation-modal.component.html',
  styleUrls: ['./withdraw-simulation-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WithdrawSimulationModalComponent implements OnInit {

  @Input() cr!: CalculatorResult;
  @Input() current!: ScheduleDate;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
  }

}
